import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import TagBadge from 'components/TagBadge';

/**
 * Tag checkboxes
 * @param {boolean} defaultChecked - Default checked
 * @param {function} handleTagChecked - Handle tag checked
 * @param {string} className - Class name
 * @param {array} tags - Tags
 * @param {boolean} disabledCheckbox - Disabled checkbox
 */
const TagCheckboxes = ({ defaultChecked, handleTagChecked, className, tags, disabledCheckbox }) => {
  if (!tags?.length) {
    return null;
  }

  return (
    <div className={`${className || ''} tags-list`}>
      {tags.map((tagData) => (
        <ListItem
          key={tagData._id}
          tagData={tagData}
          defaultChecked={defaultChecked}
          handleTagChecked={handleTagChecked}
          disabledCheckbox={disabledCheckbox}
        />
      ))}
    </div>
  );
};

/**
 * Tag checkboxes default props
 */
TagCheckboxes.defaultProps = {
  defaultChecked: false,
  handleTagChecked: () => {},
  className: '',
  tags: [],
  disabledCheckbox: false,
};

/**
 * Tag checkboxes prop types
 * @param {boolean} defaultChecked - Default checked
 * @param {function} handleTagChecked - Handle tag checked
 * @param {string} className - Class name
 * @param {array} tags - Tags
 * @param {boolean} disabledCheckbox - Disabled checkbox
 */
TagCheckboxes.propTypes = {
  defaultChecked: PropTypes.bool,
  handleTagChecked: PropTypes.func,
  className: PropTypes.string,
  tags: PropTypes.array,
  disabledCheckbox: PropTypes.bool,
};

export default TagCheckboxes;

/**
 * List item
 * @param {object} tagData - Tag data
 * @param {boolean} defaultChecked - Default checked
 * @param {function} handleTagChecked - Handle tag checked
 * @param {boolean} disabledCheckbox - Disabled checkbox
 */
const ListItem = ({ tagData, defaultChecked, handleTagChecked, disabledCheckbox }) => {
  return (
    <li className="tag-li" key={tagData._id}>
      <Checkbox
        defaultChecked={defaultChecked}
        className="tag-checkbox"
        disabled={disabledCheckbox}
        onChange={(e) => {
          if (handleTagChecked) {
            handleTagChecked(tagData._id, e.target.checked, tagData);
          }
        }}>
        <TagBadge {...tagData} />
      </Checkbox>
    </li>
  );
};

/**
 * List item prop types
 * @param {object} tagData - Tag data
 * @param {boolean} defaultChecked - Default checked
 * @param {function} handleTagChecked - Handle tag checked
 * @param {boolean} disabledCheckbox - Disabled checkbox
 */
ListItem.propTypes = {
  tagData: PropTypes.object,
  defaultChecked: PropTypes.bool,
  handleTagChecked: PropTypes.func,
  disabledCheckbox: PropTypes.bool,
};
